import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';

const ProfileChecklistReflectionSummary = IPT.contains({
  userProfileId: PT.number.isRequired,
  checklistItemId: PT.number.isRequired,
  checklistItemDescription: PT.string.isRequired,
  checked: PT.bool,
});

const ProfileQuestionResponseSummaryRow = IPT.contains({
  userId: PT.number.isRequired,
  userProfileId: PT.number.isRequired,
  userFirstName: PT.string.isRequired,
  userLastName: PT.string.isRequired,
  answer: PT.oneOfType([PT.string, IPT.map]),
  correct: PT.bool,
  grokked: PT.number,
  checklistReflections: IPT.listOf(ProfileChecklistReflectionSummary),
});

export default {
  ProfileChecklistReflectionSummary,
  ProfileQuestionResponseSummaryRow,
};
